import { gsePricingApi } from 'app/services/api';

import { toInlineError } from '../marginCenter.actionUtils';

// The Freddie quarantine rules (soft anomaly bands) are read and saved by the card that shows them,
// so these thunks return the outcome ({ data, error }) and keep nothing in the store; a 400 for an
// out-of-range value is returned for the card to show inline.
export const readAnomalyThresholdsAction = () => async () => {
  try {
    const { data } = await gsePricingApi.getAnomalyThresholds();

    return { data: data ?? null, error: null };
  } catch (error) {
    return { data: null, error: toInlineError(error) };
  }
};

export const saveAnomalyThresholdsAction = overrides => async () => {
  try {
    const { data } = await gsePricingApi.updateAnomalyThresholds(overrides);

    return { data: data ?? null, error: null };
  } catch (error) {
    return { data: null, error: toInlineError(error) };
  }
};
